import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { Observable } from 'rxjs';
import { ResposeGeneric } from 'src/app/core/shared/respose-generic';
import { environment } from 'src/environments/environment';

@Injectable()
export class UserService {
  uriUser = environment.urlServices + 'usuarios';
  uriEmployees = this.uriUser + '/empleados';

  constructor(private httpClient: HttpClient, private utilityService: UtilityService) { }

  getUserInformation(user, cedula): Observable<ResposeGeneric>  {
    const param = { usuario: user , cedula : cedula};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriUser, param));
  }

  getEmployees(cedula, nombre, estamento): Observable<ResposeGeneric> {
    const param = { cedula: cedula, nombre: nombre , estamento: estamento};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriEmployees, param));
  }
}
